import { ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';

import { AnalyzeService } from '@services/analyze.service';
import _ from 'lodash';
import { SankeyComponent } from '@components/charts/sankey/sankey.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-sankey-wrapper',
  standalone: true,
  imports: [SankeyComponent],
  templateUrl: './sankey-wrapper.component.html',
  styleUrls: ['./sankey-wrapper.component.scss']
})
export class SankeyWrapperComponent implements OnInit {
  data: any;
  private readonly destroyRef = inject(DestroyRef);
  private readonly analyzeService = inject(AnalyzeService);

  ngOnInit(): void {
    this.analyzeService
      .getAnalyzeData()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        this.init(_.cloneDeep(res));
      });
  }

  init(data: any) {
    this.data = undefined;
    document.querySelectorAll('.tooltip').forEach((element: any) => {
      element.style.opacity = 0;
    });
    const isGridDrilling = !this.analyzeService.getGridDrillingMode();
    if (data && data.nodes && isGridDrilling) {
      this.data = undefined;
      setTimeout(() => {
        if (data.nodes?.length > 500) {
          return;
        }
        data.nodes?.forEach((item) => {
          item.needsValidation = true;
        });
        this.data = {
          type: 'sankey',
          data
        };
      }, 100);
    }
  }
}
